import React from 'react';

export default function DepartmentPerformanceTable({ data = [], isLoading = false }) {
  if (isLoading) {
    return (
      <div className="bg-white rounded-xl p-5 md:p-6 shadow-xs border border-gray-100/80">
        <div className="flex items-center justify-between mb-4">
          <div className="h-6 w-48 bg-gray-200 rounded animate-pulse" />
        </div>
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-10 bg-gray-100 rounded-lg animate-pulse" />
          ))}
        </div>
      </div>
    );
  }

  const items = Array.isArray(data) ? data : [];

  const getRateBadge = (rateStr, totalAssigned) => {
    if (totalAssigned === 0 || !rateStr || rateStr === "—" || rateStr === "N/A") {
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-500">
          —
        </span>
      );
    }
    const rateNum = parseInt(rateStr, 10) || 0;
    if (rateNum >= 90) {
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-100/80 text-emerald-700">
          {rateStr}
        </span>
      );
    }
    if (rateNum >= 70) {
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-amber-100/80 text-amber-700">
          {rateStr}
        </span>
      );
    }
    return (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-rose-100/80 text-rose-700">
        {rateStr}
      </span>
    );
  };

  return (
    <div className="bg-white rounded-xl p-5 md:p-6 shadow-xs border border-gray-100/80">
      {/* Title & Subtitle */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1 mb-4">
        <div>
          <h3 className="text-base md:text-lg font-bold text-gray-800">
            Hiệu suất đơn vị xử lý
          </h3>
          <p className="text-xs text-gray-400 mt-0.5">
            Tổng quan hiệu suất và tỷ lệ đúng hạn của tất cả các lĩnh vực / đơn vị chuyên môn
          </p>
        </div>
      </div>

      {/* Table Container */}
      <div className="w-full overflow-x-auto">
        {items.length === 0 ? (
          <div className="text-center py-8 text-sm text-gray-500">
            Chưa có dữ liệu hiệu suất đơn vị trong kỳ này.
          </div>
        ) : (
          <table className="w-full text-left border-collapse min-w-[700px]">
            <thead>
              <tr className="bg-gray-50/80 text-gray-500 text-[11px] font-bold uppercase tracking-wider">
                <th className="py-3 px-4 rounded-l-xl">Đơn vị / Lĩnh vực</th>
                <th className="py-3 px-4 text-center">Tổng được giao</th>
                <th className="py-3 px-4 text-center">Đang xử lý</th>
                <th className="py-3 px-4 text-center">Hoàn thành</th>
                <th className="py-3 px-4 text-center">Đúng hạn</th>
                <th className="py-3 px-4 text-center">Trễ hạn</th>
                <th className="py-3 px-4 text-right rounded-r-xl">Tỷ lệ đúng hạn</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100/70 text-xs md:text-sm">
              {items.map((dept, index) => (
                <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                  <td className="py-3.5 px-4 font-semibold text-gray-900">
                    {dept.name}
                  </td>
                  <td className="py-3.5 px-4 text-center text-gray-600 font-medium">
                    {dept.totalAssigned}
                  </td>
                  <td className="py-3.5 px-4 text-center text-gray-600 font-medium">
                    {dept.processing}
                  </td>
                  <td className="py-3.5 px-4 text-center text-gray-600 font-medium">
                    {dept.completed}
                  </td>
                  <td className="py-3.5 px-4 text-center font-medium text-emerald-600">
                    {dept.onTime}
                  </td>
                  <td className="py-3.5 px-4 text-center font-medium text-rose-600">
                    {dept.overdue}
                  </td>
                  <td className="py-3.5 px-4 text-right">
                    {getRateBadge(dept.rate, dept.totalAssigned)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

